<template>
  <div class="main-content">
    <TabelaCampanhas/>
    <TabelaClientes class="mt-5"/>
  </div>
</template>

<script>
import TabelaCampanhas from '@/views/app/crm/campanhas/tabelacampanhas'
import TabelaClientes from '@/views/app/crm/campanhas/tabelaclientes'

export default {
  components: {
    TabelaCampanhas,
    TabelaClientes
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style scoped>
</style>
